import React, { useState } from 'react';

const ResultDisplay = ({ 
  originalImage, 
  resultImage, 
  resultMeta,
  isLoading, 
  error, 
  onDownload, 
  serviceName 
}) => {
  const [sliderValue, setSliderValue] = useState(50);

  const handleSliderChange = (e) => {
    setSliderValue(e.target.value);
  };

  const handleDownload = () => {
    if (onDownload) {
      const timestamp = new Date().toISOString().slice(0, 19).replace(/[-:]/g, '').replace('T', '_');
      const filename = `Vanilla_${serviceName.replace(/\s+/g, '_')}_${timestamp}.png`;
      const maybePromise = onDownload(filename);
      if (maybePromise && typeof maybePromise.catch === 'function') {
        maybePromise.catch((err) => console.warn('Download cancelled', err));
      }
    }
  };

  if (isLoading) {
    return (
      <div className="w-full aspect-square bg-primary-900 bg-opacity-80 rounded-xl flex flex-col items-center justify-center text-center p-6 shadow-primary-lg">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
        <p className="text-lg font-semibold text-white">Đang nhận dữ liệu từ backend...</p>
        <p className="text-white text-sm">Vui lòng chờ trong giây lát.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full aspect-square bg-red-100 rounded-xl flex flex-col items-center justify-center text-center p-6 border border-red-200">
        <i className="ph-warning text-7xl text-red-400 mb-4"></i>
        <p className="text-lg font-semibold text-red-600">Có lỗi xảy ra</p>
        <p className="text-red-500 text-sm mt-2">{error}</p>
      </div>
    );
  }

  if (!resultImage || !originalImage) {
    console.log('❌ Missing images:', { resultImage: !!resultImage, originalImage: !!originalImage });
    if (resultMeta?.message) {
      return (
        <div className="w-full aspect-square bg-gray-100 rounded-xl flex flex-col items-center justify-center text-center p-6 border border-gray-200">
          <i className="ph-image text-7xl text-gray-400 mb-4"></i>
          <p className="text-lg font-semibold text-gray-600">Phản hồi từ backend</p>
          <p className="text-gray-500 text-sm mt-2 max-w-xs">{resultMeta.message}</p>
        </div>
      );
    }

    return (
      <div className="w-full aspect-square bg-gray-100 rounded-xl flex flex-col items-center justify-center text-center p-6 border border-gray-200">
        <i className="ph-image text-7xl text-gray-400 mb-4"></i>
        <p className="text-lg font-semibold text-gray-600">Kết quả mô phỏng của bạn</p>
        <p className="text-gray-500">sẽ xuất hiện ở đây...</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {console.log('🖼️ Rendering:', { 
        originalImage: originalImage?.substring(0, 50), 
        resultImage: resultImage?.substring(0, 50),
        areSame: originalImage === resultImage 
      })}
      {/* Before/After Slider */}
      <div className="relative w-full aspect-square rounded-xl overflow-hidden shadow-lg">
        <img 
          src={resultImage} 
          alt="Ảnh AI (SAU)" 
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div 
          className="absolute inset-0 overflow-hidden"
          style={{
            clipPath: `polygon(0 0, ${sliderValue}% 0, ${sliderValue}% 100%, 0 100%)`
          }}
        >
          <img 
            src={originalImage} 
            alt="Ảnh gốc (TRƯỚC)" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Slider Handle */}
        <div 
          className="absolute top-0 bottom-0 w-1 bg-white shadow-lg z-20 cursor-col-resize"
          style={{ left: `${sliderValue}%`, transform: 'translateX(-50%)' }}
        >
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center">
            <i className="ph-arrows-horizontal text-gray-600"></i>
          </div>
        </div>
        
        {/* Slider Input */}
        <input
          type="range"
          min="0"
          max="100"
          value={sliderValue}
          onChange={handleSliderChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-col-resize z-30"
          aria-label="Kéo để so sánh"
        />
      </div>

      {/* Labels */}
      <div className="flex justify-between text-sm font-semibold text-gray-700 px-1">
        <span>TRƯỚC</span>
        <span>SAU</span>
      </div>

      {/* Download Button */}
      <button
        onClick={handleDownload}
        className="w-full py-3 px-6 bg-green-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-green-700 transition-all flex items-center justify-center gap-2"
      >
        <i className="ph-download-simple text-xl"></i>
        <span>Tải xuống ảnh kết quả</span>
      </button>

      {resultMeta?.message && (
        <div className="text-sm text-gray-600 text-center">
          {resultMeta.message}
        </div>
      )}
      {resultMeta?.error && (
        <div className="text-sm text-red-500 text-center">
          {resultMeta.error}
        </div>
      )}
    </div>
  );
};

export default ResultDisplay;